export function ComponentNewsletterPopup() {
  var timeOfArrival = localStorage.getItem('time-of-arrival');
  var newsletterPopupShow = localStorage.getItem('newsletter-popup-show');

  if (!timeOfArrival) {
    var currentTime = new Date();
    timeOfArrival = parseInt(currentTime.getTime() / 1000);
    localStorage.setItem('time-of-arrival', timeOfArrival);
  }

  setInterval(() => {
    var currentTime = new Date();

    if (newsletterPopupShow != 'true' && parseInt(currentTime.getTime() / 1000) - timeOfArrival > 30) {
      localStorage.setItem('newsletter-popup-show', true);
      newsletterPopupShow = 'true';
      $('#newsletter-popup').addClass('active');
    }
  }, 1000);

  $('#newsletter-popup input[type="submit"]').on('click', function(e) {
    $('#newsletter-popup').removeClass('active');
  });

  $('#button-newsletter-popup-close').on('click', function(e) {
    e.preventDefault();

    $('#newsletter-popup').removeClass('active');
  });
}
